import React from 'react';

const SvgKp = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KP_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KP_svg__b" fill="#fff">
        <use xlinkHref="#KP_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#KP_svg__a" />
      <path
        fill="#1461B6"
        mask="url(#KP_svg__b)"
        d="M0 0h28v4H0zM0 16h28v4H0z"
      />
      <path fill="#FFF" mask="url(#KP_svg__b)" d="M0 4h28v12H0z" />
      <path fill="#F53846" mask="url(#KP_svg__b)" d="M0 5.333h28v9.333H0z" />
      <path
        d="M10 13.333a3.333 3.333 0 1 1 0-6.666 3.333 3.333 0 0 1 0 6.666zm0-1.995l1.96 1.359-.688-2.284L13.17 8.97l-2.384-.052L10 6.667l-.786 2.25-2.384.053 1.898 1.443-.687 2.284L10 11.337z"
        fill="#FFF"
        mask="url(#KP_svg__b)"
      />
    </g>
  </svg>
);

export default SvgKp;
